import React from 'react'
import PropTypes from 'prop-types'
import { Field } from 'redux-form'
import withFieldError from 'components/form/with-error'

const MessageInput = ({ input, placeholder }) => (
  <div>
    <input
      className={'form-control right-element-no-borders '}
      type='text'
      placeholder={placeholder}
      {...input}
    />
  </div>
)

MessageInput.propTypes = {
  input: PropTypes.any,
  type: PropTypes.string,
  label: PropTypes.string,
  meta: PropTypes.any,
  placeholder: PropTypes.string
}

const MessageInputWithError = withFieldError(MessageInput)

const FacebookOneTimeConsentFields = ({ name }) => (
  <div className='row'>
    <div className='col-sm-12'>
      <Field
        component={MessageInputWithError}
        label='One Time Consent Title'
        name={`${name}.oneTimeConsentTitle`}
        placeholder='Title'
      />
    </div>
  </div>
)

FacebookOneTimeConsentFields.propTypes = {
  name: PropTypes.string
}

export default FacebookOneTimeConsentFields



// WEBPACK FOOTER //
// ./src/pages/widgets/form/configure-triggers-actions/actions/facebook/facebook-onetime-consent/index.js